import { RentalModalFilterComponent } from "./rental-modal-filter/rental-modal-filter.component";
import { Component, OnInit, ViewChild } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { HeaderModel } from "src/app/_component/header/header.model";
import { UserService } from "src/app/_services";
import { ThisPlatform } from "src/app/_services/platform.service";
import { RowsLoaderService } from "src/app/_services/rows-loader.service";
import { PaginationClientSideOptions } from "../_component/pagination-client-side/pagination-client-side-options";
import { PaginationColumn } from "../_component/pagination-client-side/pagination-column.class";
import { RentalViewComponent } from "./rental-view/rental-view.component";
import { Item, ItemType } from "./rental.model";
import { RentalService } from "./rental.service";
import { HeaderService } from "src/app/_services/header.service";
import { preventSwipeToClose } from "src/app/_helpers/preventSwipeToClose";

@Component({
  selector: "app-rental",
  templateUrl: "./rental.page.html",
  styleUrls: ["./rental.page.scss"],
})
export class RentalPage implements OnInit {
  constructor(
    private userServ: UserService,
    public p: ThisPlatform,
    public translateServ: TranslateService,
    public rentalServ: RentalService,
    private modalCtrl: ModalController,
    private headerServ: HeaderService,
  ) {}

  rentalAddRole = false;
  componentRef: any = RentalViewComponent;
  itemsFilter: Item[];
  showLoader: boolean;
  rentalStatusArray = [
    {
      id: "ALL",
      name: this.translateServ.instant("ALL"),
    },
    {
      id: "AVAILABLE",
      name: this.translateServ.instant("RENTAL.STATUS.AVAILABLE"),
    },
    {
      id: "RESERVATION",
      name: this.translateServ.instant("RENTAL.STATUS.RESERVATION"),
    },
    {
      id: "RENT",
      name: this.translateServ.instant("RENTAL.STATUS.RENT"),
    },
  ];

  columnsDefinition: PaginationColumn[] = [
    {
      name: "logo",
      displayName: "Logo",
      size: 1,
      sortable: false,
    },
    {
      name: "name",
      displayName: "NAME",
      size: 2,
      sortable: true,
    },
    {
      name: "description",
      displayName: "DESCRIPTION",
      size: 3,
      sortable: true,
      colValue: (row) => {
        return row.description;
      },
    },
    {
      name: "status",
      displayName: "RENTAL.STATUS.STATUS",
      size: 2,
      sortable: false,
    },
    {
      name: "rentalAndReservationCount",
      displayName: "",
      size: 2,
      sortable: false,
    },
    {
      name: "button",
      displayName: "",
      size: 2,
      sortable: false,
    },
  ];

  options: PaginationClientSideOptions = {
    ...new PaginationClientSideOptions(),
    headerStickyPosition: 125,
    addButtonText: "ADD",
    noResultsAddLink: "/app/building/add",
    mobileFilterButton: true,
    permissionAdd: "rental.add",
  };

  rowsLoader: RowsLoaderService;
  headerInit: HeaderModel ={
    title: "MENU.RENTAL",
    segments: [],
    mobileSegments: [],
  }; 

  @ViewChild("searchBar")
  searchBar;

  async ngOnInit() {
    this.rentalAddRole = await this.userServ.hasRolesAsync(["rental.add"]);
    this.rentalServ.handleStausChange().subscribe(() => {
      this.rowsLoaderInit();
    });
  }
  
  ionViewWillEnter() {
    this.headerServ.setHeaderInit(this.headerInit);
    this.getItems();
  }

  getItems() {
    this.showLoader = true;
    this.rentalServ.getItems(ItemType.Book).subscribe((res) => {
      this.rentalServ.items = res;
      this.itemsFilter = res;
      this.rowsLoaderInit();
    });
  }

  onChangeSearch() {
    this.rowsLoaderInit();
  }

  rowsLoaderServiceReady(loader: RowsLoaderService) {
    this.rowsLoader = loader;
  }

  rowsLoaderInit() {
    if (this.rowsLoader) {
      if (this.searchBar.ngModel) {
        this.itemsFilter = this.rentalServ.items.filter((s) =>
          (
            s.name.toUpperCase() +
            " " +
            (s.description ? s.description.toUpperCase() : "")
          ).includes(this.searchBar.ngModel.toUpperCase())
        );
      } else {
        this.itemsFilter = this.rentalServ.items;
      }
      if (this.rentalServ.getCurrentStatus().length) {
        this.itemsFilter = this.itemsFilter.filter((e) => {
          return e.rentalStatus === this.rentalServ.getCurrentStatus();
        });
      }
      this.rowsLoader.init(this.itemsFilter);
      this.rentalServ.filteredElementsLength = this.itemsFilter.length;
      this.showLoader = false;
    }
  }

  async handleActionRequest(action) {
    if (action.type === "reservation") {
      await this.rentalServ.itemRentalReservation(action.id);
      this.getItems();
    }
  }

  onStatusChanged(event) {
    this.rentalServ.setCurrentStatus(event.id);
    this.rowsLoaderInit();
  }

  async onToggleFilter() {
    const modal = await this.modalCtrl.create({
      component: RentalModalFilterComponent,
      componentProps: {
        statusOptions: this.rentalStatusArray,
      },
      canDismiss: preventSwipeToClose,
      cssClass: "add-edit-modal mobile-filter__modal-container",
    });
    modal.present();
  }
}
